import { Route } from "react-router";

import { Env } from "@/shared/environment";
import { Goto } from "@/shared/navigation/Goto";
import { featureFlagRoute } from "@/shared/routing/featureFlagRoute";

import { FoxgloveIntegration } from "./FoxgloveIntegration";
import { S3Integration } from "./S3Integration";
import { S3BucketExplorer } from "./S3Integration/S3BucketExplorer";
import { SlackIntegration } from "./SlackIntegration";

/**
 * Spreads its `<Route>`s into the data router (rather than rendering a descendant `<Routes>`)
 * for the same reason as datasets and devices: only routes in the data-router config get their
 * `loader` run, and the Foxglove gate below is a loader.
 */
export const IntegrationsRoutes = () => [
  featureFlagRoute({
    path: "foxglove",
    flagName: "integration-foxglove",
    redirectTo: Goto.route.Settings.Integrations.Root,
    element: <FoxgloveIntegration />,
  }),
  <Route key="s3" path="s3" element={<S3Integration />} />,
  <Route
    key="s3-bucket"
    path="s3/:bucketName"
    element={<S3BucketExplorer />}
  />,
  // Unregistered where the deployment does not serve Slack, so the URL falls through to the
  // router's catch-all. Slack's OAuth callback is NOT here — it needs a loader that must run
  // outside AppLayout, so it lives in the data router.
  ...(Env.slackEnabled
    ? [<Route key="slack" path="slack" element={<SlackIntegration />} />]
    : []),
];
